export default __webpack_public_path__ + "ed752c9361542cb3682a4f1aaf0d102e.mp3";